"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "seriate": {
    "7a42e73a": [{
      "hkey": "66e95ed0",
      "slug": "seriate",
      "name": "Seriate",
      "primary": true,
      "skipSearch": false
    }],
    "cassinone": [{
      "hkey": "66e95ed0",
      "slug": "seriate",
      "name": "Seriate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "172030b8": [{
      "hkey": "66e95ed0",
      "slug": "seriate",
      "name": "Seriate",
      "primary": true,
      "skipSearch": false
    }],
    "comonte": [{
      "hkey": "66e95ed0",
      "slug": "seriate",
      "name": "Seriate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "59ddb4d3": [{
      "hkey": "66e95ed0",
      "slug": "seriate",
      "name": "Seriate",
      "primary": true,
      "skipSearch": false
    }],
    "paderno": [{
      "hkey": "66e95ed0",
      "slug": "seriate",
      "name": "Seriate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;